import React, { useEffect, useState, useRef } from 'react'
import {
    TextField, MenuItem, Autocomplete,
    FormControl
} from '@mui/material'
import { createFilterOptions } from '@mui/material/Autocomplete';
import { inputClasses } from '../../../static/styles/theme'
import CheckIcon from "@mui/icons-material/Check";
import { customAPI_For_APIPara } from "../../../services/formFunction"
import { debounce } from '@mui/material/utils';
import { selectStylesOverride } from '../../../utils/util';
import { Add } from '@mui/icons-material';
import theme from '../../../static/styles/theme';
import AddReason from '../AddModel/AddReason';

const filterMethod = createFilterOptions({
    stringify: (option) =>
        option?.renderOptionLabel || option?.label || option?.value?.toString?.() || '',
});

const TypeAndSearch = ({
    component, label, value, options = [], handleChange, setEmptyOnChange = false, resetOption = true,
    disabled, set_Value = false, addNewOptions = {}, reasonType = "", componentStyle = {}, detailObject = {}, notAutoSelectFirstOption = false,
    children
}) => {

    const [selectOptions, setSelectOptions] = useState([]);
    const [initial, setInitial] = useState(true);
    const [inputValue, setInputValue] = useState('');
    const [searching, setSearching] = useState("");
    const [openReasonModal, setOpenReasonModel] = useState(false);
    const [enableFetch, setEnableFetch] = useState(false);
    // Debounced fetches (below) can resolve after the component has unmounted (dropdown closed,
    // filter panel swapped, etc.) — guard every async setState with this so React doesn't warn
    // about state updates on an unmounted component.
    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const usePrevious = (value = "") => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        }, [value]);
        return ref.current;
    };

    const prevInput = usePrevious(inputValue);

    const fetch = React.useMemo(
        () =>
            debounce(async (component, value, detail, callback) => {
                setSearching("Searching...")
                await customAPI_For_APIPara(component, value, detail, callback)
            }, 400),
        [],
    );

    useEffect(() => {
        let active = true;
        if (initial) {
            if (component?.dynamic) {
                let temp_option = []
                if ((label && value) || options?.length > 0) {
                    temp_option = options?.length > 0 ? options : [{ label, value }];
                    if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
                        temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
                    }
                    setSelectOptions(temp_option)
                    setInitial(false)
                    setSearching("")
                }
                else if (!component.dontFetch) {
                    fetch(component, label || value, detailObject, (results) => {
                        if (!active || !isMountedRef.current) return;
                        if (results) {
                            temp_option = [...results];
                        }
                        if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
                            temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
                        }
                        setSelectOptions(temp_option)
                        if (!notAutoSelectFirstOption && temp_option?.length == 1) {
                            handleChange({ target: { value: temp_option[0]?.value || "" } }, temp_option[0])
                        }
                        setSearching("")
                    });
                    setInitial(false)
                } else {
                    if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
                        temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
                    }
                    setSelectOptions(temp_option)
                    setInitial(false)
                    setSearching("")
                }
            } else {
                setInitial(false)
            }
        } else {
            if ((label && value) || options?.length > 0) {
                let temp_option = options?.length > 0 ? options : [{ label, value }];
                if ((addNewOptions.isEnabled || addNewOptions.isFreeSolo) && addNewOptions.label) {
                    temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
                }
                setSelectOptions(temp_option)
                setInitial(false)
                setSearching("")
            }
        }

        return () => {
            active = false;
        };
    }, [value, label]);

    // useEffect(() => {
    //     let active = true;
    //     if (!initial && component?.dynamic && enableFetch) {
    //         if (!inputValue) {
    //             let temp_option = []
    //             if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
    //                 temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
    //             }

    //             if (!component.dontFetch) {
    //                 fetch(component, "",detailObject, (results) => {
    //                     setSearching("")
    //                     if (active && results) {
    //                         temp_option = [...temp_option, ...results];
    //                     }
    //                     setSelectOptions(temp_option);
    //                     setEnableFetch(false)
    //                 });
    //             } else {
    //                 setSelectOptions([...temp_option, ...selectOptions])
    //                 setSearching("")
    //                 setEnableFetch(false)
    //             }
    //         }
    //         else if (prevInput !== inputValue) {
    //             fetch(component, inputValue,detailObject, (results) => {
    //                 setSearching("")
    //                 let newOptions = [];
    //                 if (active && results) {
    //                     newOptions = [...newOptions, ...results];
    //                 }
    //                 if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
    //                     newOptions.unshift({ label: addNewOptions.label, value: 'addNew' })
    //                 }
    //                 setSelectOptions(newOptions);
    //                 setEnableFetch(false)
    //             });
    //         } else {
    //             setEnableFetch(false)
    //         }
    //     }

    //     return () => {
    //         active = false;
    //     };
    // }, [inputValue]);

    // const fetchNewData = (tempSearch = null) => {
    //     let temp_option = []
    //     if (["UOM", "vehicleNo"].includes(component?._id)) {
    //         if ((addNewOptions.isEnabled || addNewOptions.isFreeSolo) && addNewOptions.label) {
    //             temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
    //         }
    //     }
    //     fetch(component, tempSearch || inputValue,detailObject, (results) => {
    //         setSearching("")
    //         if (results) temp_option = [...temp_option, ...results];
    //         setSelectOptions(temp_option);
    //     });
    // }

    const fetchNewData = (tempSearch = null, reason = "") => {
        let temp_option = []
        const lowerSearch = tempSearch?.toLowerCase()
        if (selectOptions?.some(el => (typeof el?.value === "string" ? el?.value?.toLowerCase() : el?.value) === lowerSearch || (typeof el?.label === "string" ? el?.label?.toLowerCase() : el?.label) === lowerSearch)) {
            return
        }
        if (["UOM", "vehicleNo"].includes(component?._id)) {
            if ((addNewOptions.isEnabled || addNewOptions.isActive || addNewOptions.isFreeSolo) && addNewOptions.label) {
                temp_option.unshift({ label: addNewOptions.label, value: 'addNew' })
            }
        }
        const searchValue = reason === "clear" ? "" : (tempSearch || inputValue)
        fetch(component, searchValue, detailObject, (results) => {
            if (!isMountedRef.current) return;
            setSearching("")
            if (results) temp_option = [...temp_option, ...results];
            setSelectOptions(temp_option);
        });
    }

    return (
        <FormControl fullWidth size="small">
            <Autocomplete
                id={component?._id || "type-and-search"}
                disableClearable={!inputValue}
                sx={{ ...componentStyle, ...inputClasses.themeBoundary }}
                filterOptions={(options, params) => {
                    const filtered = filterMethod(options, params);
                    if (
                        (addNewOptions.isFreeSolo || addNewOptions.isEnabled) &&
                        params.inputValue !== '' &&
                        !options.some(el => el?.label === params.inputValue || el?.value === params.inputValue)
                    ) {
                        filtered.unshift({
                            value: params.inputValue,
                            label: `Add "${params.inputValue}"`,
                            addMethod: "isAddOption"
                        });
                    }
                    return filtered;
                }}
                options={searching ? [] : selectOptions}
                disabled={disabled}
                // value={
                //     !notAutoSelectFirstOption
                //         ? null
                //         : (value
                //             ? selectOptions.find(dl => dl.value === value) || null
                //             : null)
                // } 
                value={label || (value && selectOptions.find(dl => dl.value === value)?.label) || ""}
                autoComplete
                size="small"
                includeInputInList
                filterSelectedOptions
                onFocus={() => {
                    if (!label && !value) {
                        setSearching("wait....")
                        // setSelectOptions([])
                        fetchNewData(label || "")
                    }
                }}
                onBlur={() => {
                    setSearching("")
                }}
                noOptionsText={searching
                    ? searching
                    : inputValue && "No Data Found" || "Type Here..."
                }
                onChange={(event, newValue) => {
                    if (newValue?.addMethod === "isAddOption" && addNewOptions.isFreeSolo) {
                        handleChange({ target: { value: newValue?.value || "" } }, newValue)
                        setInputValue(newValue?.value || "");
                    } else {
                        handleChange({ target: { value: newValue?.value || "" } }, newValue)
                        if (setEmptyOnChange) {
                            setInputValue("")
                        }
                    }
                    setEnableFetch(!newValue)
                }}
                // onInputChange={(event, newInputValue, reason) => {
                //     setInputValue(newInputValue);
                //     if (["input", "clear"].includes(reason)) {
                //         setSelectOptions([])
                //     }
                //     setSearching(newInputValue ? "Typing..." : "")
                //     setEnableFetch(newInputValue !== prevInput || false)
                // }}
                onInputChange={(event, newInputValue, reason) => {
                    const lowerSearch = newInputValue?.toLowerCase()
                    // console.log("reason", reason)
                    setInputValue(newInputValue);
                    if (["clear"].includes(reason)) {
                        setSearching("wait....")
                        fetchNewData("", reason)
                    }
                    else if (["input"].includes(reason) && component?.dynamic && newInputValue !== prevInput && !selectOptions?.some(el => ((typeof el?.value === "string" ? el?.value?.toLowerCase() : el?.value) === lowerSearch || (typeof el?.label === "string" ? el?.label?.toLowerCase() : el?.label) === lowerSearch))) {
                        setSearching(newInputValue ? "Typing..." : "")
                        fetchNewData(newInputValue, reason);
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`${component?.placeholder || component.label}${component.required ? "*" : ""}`}
                        fullWidth
                        sx={selectStylesOverride}
                    />
                )}
                renderOption={(props, option, { selected }) => {
                    if ((addNewOptions.isFreeSolo || addNewOptions.isEnabled) && option.addMethod === "isAddOption") {
                        return (
                            <MenuItem
                                key={option.value}
                                sx={{ color: theme.themeOrange }}
                                {...props}
                            >
                                <Add fontSize='inherit' /> {option?.label || ""}
                            </MenuItem>
                        );
                    }

                    return (
                        <MenuItem
                            key={option.value}
                            value={option.value}
                            sx={{ justifyContent: "space-between" }}
                            {...props}
                        >
                            {option?.label || ""}
                            {selected ? <CheckIcon color="info" /> : null}
                        </MenuItem>
                    );
                }}
                inputValue={inputValue}
            />
            {children || ""}
            {openReasonModal && (
                <AddReason
                    open={openReasonModal}
                    setOpenReasonModel={setOpenReasonModel}
                    type={reasonType || ""}
                    fetchNewData={fetchNewData}
                />
            )}
        </FormControl>
    )
}

export default TypeAndSearch;
